import { render } from "./ObjSet.vue?vue&type=template&id=6f153a78"
import script from "./ObjSet.vue?vue&type=script&lang=js"
export * from "./ObjSet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__